import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import React from 'react';

export const PRIOR_WEEK_CHECK_IN_PROMPT =
    'What was your biggest takeaway from last week, and how did you apply that learning throughout the week? What impact, if any, did it have?';

interface PriorWeekCheckInBubbleProps {
    color: string;
    borderColor?: string;
}

const PriorWeekCheckInBubble: React.FC<PriorWeekCheckInBubbleProps> = ({ color, borderColor }) => {
    const theme = useTheme();
    const accentColor = borderColor ?? theme.palette.success.main;

    return (
        <Paper
            elevation={0}
            data-testid="lesson-plan-prior-week-check-in"
            sx={{
                mb: 1,
                p: 2.5,
                backgroundColor: color,
                borderLeft: `4px solid ${accentColor}`,
                borderRadius: '18px 0 0 0',
                position: 'relative',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <ChatBubbleOutlineIcon
                    sx={{
                        color: accentColor,
                        fontSize: 28,
                        mt: 0.25,
                        flexShrink: 0,
                    }}
                />
                <Box sx={{ flex: 1 }}>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            fontWeight: 'bold',
                            color: accentColor,
                            mb: 1,
                            textTransform: 'uppercase',
                            letterSpacing: 0.5,
                            fontSize: '0.75rem',
                        }}
                    >
                        Opening Check-In
                    </Typography>
                    <Typography
                        variant="h6"
                        component="p"
                        sx={{
                            color: 'text.primary',
                            lineHeight: 1.5,
                            fontWeight: 600,
                            fontSize: { xs: '1.05rem', sm: '1.25rem' },
                        }}
                    >
                        {PRIOR_WEEK_CHECK_IN_PROMPT}
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
};

export default PriorWeekCheckInBubble;
